import styled from 'styled-components';
import media from 'src/styles/Media.styled'; 
import {SMALL_TEXT_PX,X_SMALL_TEXT_PX,PRIMARY_FONT_COLOR,TITLE_FONT_COLOR,
    LARGE_TEXT_PX,
    BASE_TEXT_PX,
    DARK_NAVY_FONT_COLOR,SEMANTIC_TEXT_PX
} from '../../../../styles/fonts/MCFontConstants';

export const ItemListViewWrapper = styled.div`
    margin-bottom: 3%;
    width: ${({ width }) => width && width};
    ${media.mobileDevice`
    padding: ${({ padding }) => padding && padding};
`}
`;

export const ItemTable = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-family: 'AvenirNextWorld demi';
    font-size: ${SMALL_TEXT_PX};
    border-bottom: 1px solid #ddd;
    table-layout: fixed;
`;

export const TableHeader = styled.th`
    background-color: white;
    width: ${({ width }) => width && width};
    font-weight: bold;
    padding: 3px 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: ${X_SMALL_TEXT_PX};
    color: ${PRIMARY_FONT_COLOR};
    &.quantity {
        text-align: right;
    }
    ${media.mediumDevice`
    &.quantity {
        padding: 0px;
        text-align: left;
    }
    &.brand {
        width:22.5%;
    }
`}
`;

export const TableData = styled.td`
    padding: 12px 10px;
    font-family: 'AvenirNextWorld Regular';
    font-size: ${SMALL_TEXT_PX};
    width: ${({ width }) => width && width};
    border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
    font-weight: ${({ fontWeight }) => fontWeight && fontWeight};

    &.quantity {
        text-align: right;
        padding-right: 10px;
    }

    &.description {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
    }

    &.product {
        color: ${TITLE_FONT_COLOR};
        font-weight: bold;
        font-family:'AvenirNextWorld demi';
        cursor: pointer;
    }
    ${media.mediumDevice`
    &.brand {
        width:22.5%;
    }
`}
`;

export const TableRow = styled.tr`
    &:nth-child(even) {
        background-color: #f5f5f5cc;
    }

    &:nth-child(odd) {
        background-color: white;
    }

    // &:hover {
    //   background-color: #e0e0e0;
    // }
`;

export const ProductCfn = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: ${SEMANTIC_TEXT_PX};
    font-weight: 600;
    line-height: 31.28px;
    color: ${TITLE_FONT_COLOR};
`;

export const ProductData = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
`;

export const Quantity = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: ${BASE_TEXT_PX};
    font-weight: 400;
    line-height: 27.81px;
    color: #000000c4;
`;

export const ProductContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 4% 10px 4%;
    border-top: ${({ borderTop }) => borderTop && borderTop};
    border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
    &:nth-child(even) {
        background-color: #f5f5f5cc;
    }

    &:nth-child(odd) {
        background-color: white;
    }
`;

export const TypeText = styled.div`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 43%;
    display: inline;
    padding-left: 9px;
    padding-right: 9px;
    margin-left: 5px;
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    text-align: center;
`;

export const Description = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: ${SMALL_TEXT_PX};
    font-weight: 400;
    line-height: 22.59px;
    color: #3c3c3c;
`;

export const Brands = styled.div`
    display: flex;
    font-family: 'AvenirNextWorld Regular';
    font-size: ${SMALL_TEXT_PX};
    font-weight: 700;
    line-height: 22.59px;
    color: #3c3c3c;
`;

export const BrandsName = styled.div`
    display: block;
    font-family: 'AvenirNextWorld Regular';
    font-size: ${SMALL_TEXT_PX};
    font-weight: 400;
    line-height: 22.59px;
    color: #3c3c3c;
`;

export const Circle = styled.div`
    display: flex;
    align-items: center;
    width: 12px;
    height: 11px;
    border: 1px solid;
    border-radius: 50%;
    justify-content: center;
    color: #00000080;
    margin-left: 0.5%;
`;
